import { Companion_getInstanceswkziix95xfy as Companion_getInstance } from './PrimitiveRanges.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../js/rangeTo.mjs';
import { Companion_instance2qx5twdgt0if1 as Companion_instance } from './Progressions.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import {
  checkStepIsPositive70940ky00dt4 as checkStepIsPositive,
  ClosedFloatingPointRange3bek8kkkwkj9x as ClosedFloatingPointRange,
} from './Ranges.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../js/compareTo.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { convertToInty04h231mmjoh as convertToInt } from '../js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function until(_this__u8e3s4, to) {
  if (to <= -2147483648)
    return Companion_getInstance().EMPTY_1;
  return numberRangeToNumber(_this__u8e3s4, to - 1 | 0);
}
function downTo(_this__u8e3s4, to) {
  return Companion_instance.fromClosedRange_y6bqsv_k$(_this__u8e3s4, to, -1);
}
function coerceAtMost(_this__u8e3s4, maximumValue) {
  return _this__u8e3s4 > maximumValue ? maximumValue : _this__u8e3s4;
}
function coerceAtLeast(_this__u8e3s4, minimumValue) {
  return _this__u8e3s4 < minimumValue ? minimumValue : _this__u8e3s4;
}
function coerceIn(_this__u8e3s4, minimumValue, maximumValue) {
  if (minimumValue > maximumValue)
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Cannot coerce value to an empty range: maximum ' + maximumValue + ' is less than minimum ' + minimumValue + '.');
  if (_this__u8e3s4 < minimumValue)
    return minimumValue;
  if (_this__u8e3s4 > maximumValue)
    return maximumValue;
  return _this__u8e3s4;
}
function step(_this__u8e3s4, step) {
  checkStepIsPositive(step > 0, step);
  return Companion_instance.fromClosedRange_y6bqsv_k$(_this__u8e3s4.first_1, _this__u8e3s4.last_1, _this__u8e3s4.step_1 > 0 ? step : -step | 0);
}
function coerceAtMost_0(_this__u8e3s4, maximumValue) {
  return compareTo(_this__u8e3s4, maximumValue) > 0 ? maximumValue : _this__u8e3s4;
}
function coerceAtLeast_0(_this__u8e3s4, minimumValue) {
  return compareTo(_this__u8e3s4, minimumValue) < 0 ? minimumValue : _this__u8e3s4;
}
function coerceIn_0(_this__u8e3s4, minimumValue, maximumValue) {
  if (minimumValue > maximumValue)
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Cannot coerce value to an empty range: maximum ' + maximumValue + ' is less than minimum ' + minimumValue + '.');
  if (_this__u8e3s4 < minimumValue)
    return minimumValue;
  if (_this__u8e3s4 > maximumValue)
    return maximumValue;
  return _this__u8e3s4;
}
function coerceIn_1(_this__u8e3s4, minimumValue, maximumValue) {
  if (minimumValue > maximumValue)
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Cannot coerce value to an empty range: maximum ' + maximumValue.toString() + ' is less than minimum ' + minimumValue.toString() + '.');
  if (_this__u8e3s4 < minimumValue)
    return minimumValue;
  if (_this__u8e3s4 > maximumValue)
    return maximumValue;
  return _this__u8e3s4;
}
function coerceIn_2(_this__u8e3s4, range) {
  if (isInterface(range, ClosedFloatingPointRange())) {
    return coerceIn_3(_this__u8e3s4, range);
  }
  if (range.isEmpty_y1axqb_k$())
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Cannot coerce value to an empty range: ' + toString(range) + '.');
  return _this__u8e3s4 < range.get_start_iypx6h_k$() ? range.get_start_iypx6h_k$() : _this__u8e3s4 > range.get_endInclusive_r07xpi_k$() ? range.get_endInclusive_r07xpi_k$() : _this__u8e3s4;
}
function coerceAtLeast_1(_this__u8e3s4, minimumValue) {
  return _this__u8e3s4 < minimumValue ? minimumValue : _this__u8e3s4;
}
function contains(_this__u8e3s4, value) {
  // Inline function 'kotlin.let' call
  var it = toIntExactOrNull(value);
  return !(it == null) ? _this__u8e3s4.contains_3tkdvy_k$(it) : false;
}
function coerceIn_3(_this__u8e3s4, range) {
  if (range.isEmpty_y1axqb_k$())
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Cannot coerce value to an empty range: ' + toString(range) + '.');
  return range.lessThanOrEquals_r7k2jg_k$(_this__u8e3s4, range.get_start_iypx6h_k$()) && !range.lessThanOrEquals_r7k2jg_k$(range.get_start_iypx6h_k$(), _this__u8e3s4) ? range.get_start_iypx6h_k$() : range.lessThanOrEquals_r7k2jg_k$(range.get_endInclusive_r07xpi_k$(), _this__u8e3s4) && !range.lessThanOrEquals_r7k2jg_k$(_this__u8e3s4, range.get_endInclusive_r07xpi_k$()) ? range.get_endInclusive_r07xpi_k$() : _this__u8e3s4;
}
function toIntExactOrNull(_this__u8e3s4) {
  return (-2147483648n <= _this__u8e3s4 ? _this__u8e3s4 <= 2147483647n : false) ? convertToInt(_this__u8e3s4) : null;
}
function coerceAtMost_1(_this__u8e3s4, maximumValue) {
  return _this__u8e3s4 > maximumValue ? maximumValue : _this__u8e3s4;
}
function coerceAtLeast_2(_this__u8e3s4, minimumValue) {
  return _this__u8e3s4 < minimumValue ? minimumValue : _this__u8e3s4;
}
function coerceAtMost_2(_this__u8e3s4, maximumValue) {
  return _this__u8e3s4 > maximumValue ? maximumValue : _this__u8e3s4;
}
function coerceIn_4(_this__u8e3s4, range) {
  if (isInterface(range, ClosedFloatingPointRange())) {
    return coerceIn_3(_this__u8e3s4, range);
  }
  if (range.isEmpty_y1axqb_k$())
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Cannot coerce value to an empty range: ' + toString(range) + '.');
  return _this__u8e3s4 < range.get_start_iypx6h_k$() ? range.get_start_iypx6h_k$() : _this__u8e3s4 > range.get_endInclusive_r07xpi_k$() ? range.get_endInclusive_r07xpi_k$() : _this__u8e3s4;
}
function coerceIn_5(_this__u8e3s4, range) {
  if (isInterface(range, ClosedFloatingPointRange())) {
    return coerceIn_3(_this__u8e3s4, range);
  }
  if (range.isEmpty_y1axqb_k$())
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Cannot coerce value to an empty range: ' + toString(range) + '.');
  return compareTo(_this__u8e3s4, range.get_start_iypx6h_k$()) < 0 ? range.get_start_iypx6h_k$() : compareTo(_this__u8e3s4, range.get_endInclusive_r07xpi_k$()) > 0 ? range.get_endInclusive_r07xpi_k$() : _this__u8e3s4;
}
//region block: exports
export {
  coerceAtLeast_2 as coerceAtLeastklytehohcpeq,
  coerceAtLeast_1 as coerceAtLeast3qxv4gros2xti,
  coerceAtLeast_0 as coerceAtLeast3jlgfquiyquc9,
  coerceAtLeast as coerceAtLeast2bkz8m9ik7hep,
  coerceAtMost_2 as coerceAtMostfyc3emgaderp,
  coerceAtMost_0 as coerceAtMost31oazapy1u82u,
  coerceAtMost_1 as coerceAtMostmgknbongtqt,
  coerceAtMost as coerceAtMost322komnqp70ag,
  coerceIn_0 as coerceIn1xblvmyr0tby6,
  coerceIn as coerceIn10f36k81le1mm,
  coerceIn_1 as coerceIn302bduskdb54x,
  coerceIn_5 as coerceIn82duc7igyjd0,
  coerceIn_2 as coerceIn1fn1ki3gdsgfi,
  coerceIn_4 as coerceIn10fbf4zn2whhq,
  contains as contains2c50nlxg7en7o,
  downTo as downTo39qhfeycepm1j,
  step as step18s9qzr5xwxat,
  until as until1jbpn0z3f8lbg,
};
//endregion

//# sourceMappingURL=_Ranges.mjs.map
